// import './utils/whyDidYouRender'; // uncomment to debug issues with too many renders - see https://github.com/welldone-software/why-did-you-render
import React from 'react';
import ReactDOM from 'react-dom';

// import { getEnvironment } from '@trqk/utils';

import { App } from './app';

// if (getEnvironment() === 'development') {
//     // eslint-disable-next-line
//     const { appSyncWorker } = require('@trqk/api');

//     appSyncWorker.start();
// }

ReactDOM.render(<App />, document.getElementById('app-root'));
